module.exports = __webpack_public_path__ + "7645cfbdb3e599427ecc71a7e2906103.svg";